import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LabReqBaseComponent } from '../lab-req-base/lab-req-base.component';
import { QC_OTHER_ANALYSES_FAX_BOILERPLATE } from './data';
import { QcProfileCheckboxComponent } from './qc-profile-checkbox/qc-profile-checkbox.component';
import { QcTestSpecificationCheckboxComponent } from './qc-test-specification-checkbox/qc-test-specification-checkbox.component';
import { QcIndividualAnalysesCheckboxComponent } from './qc-individual-analyses-checkbox copy/qc-individual-analyses-checkbox.component';
import { DynacareLogoComponent } from './dynacare-logo/dynacare-logo.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    QcProfileCheckboxComponent,
    QcIndividualAnalysesCheckboxComponent,
    QcTestSpecificationCheckboxComponent,
    DynacareLogoComponent
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'app-lab-req-qc',
  templateUrl: './lab-req-qc.component.html',
  styleUrls: ['./lab-req-qc.component.less']
})
export class LabReqQcComponent extends LabReqBaseComponent implements OnInit {
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      signature: [''],
      patient: this.fb.group({
        name: ['', Validators.required],
        firstName: ['', Validators.required],
        dob: ['', Validators.required],
        address: ['', Validators.required],
        suite: [''],
        city: ['', Validators.required],
        postalCode: ['', Validators.required],
        homeT: [''],
        mobileT: ['', Validators.required],
        healthInsurance: [''],
        sex: ['']
      }),
      collectionAgencyInfo: this.fb.group({
        collectionDate: [''],
        collectionTime: [''],
        collectedBy: [''],
        accountNumber: [''],
        clientNumber: [''],
        doctor: [''],
        permitNumber: [''],
        clinic: [''],
        address: [''],
        T: [''],
        F: [''],
        drSignature: [''],
        signatureDate: [''],
        copyToDr: [''],
        copyToDrF: ['']
      }),
      profiles: this.fb.group({
        TIBCP: [false],
        ANEM1: [false],
        SMAC: [false],
        SMACLYT: [false],
        SMA6: [false],
        SMA12: [false],
        SMA12LYT: [false],
        FERT1: [false],
        FERT2: [false],
        LIPID: [false],
        NFLIPID: [false],
        NFLIPID_fasting_hours: [false],
        LFT: [false],
        GP1: [false],
        GP2: [false],
        GP3: [false],
        GP4: [false],
        HEPAB: [false],
        HEPB: [false],
        MONOP: [false],
        OSTEOP: [false],
        PREN1: [false],
        FPSA: [false],
        STONE: [false],
        TH2: [false],
        UC: [false]
      }),
      individualAnalyses: this.fb.group({
        FETO: [false],
        ALB: [false],
        ALK: [false],
        ALT: [false],
        AMYL: [false],
        ANA: [false],
        DNA: [false],
        ENA: [false],
        TAPRO: [false],
        APOA: [false],
        APOB: [false],
        ASTO: [false],
        AST: [false],
        BSQUAL: [false],
        BSQUANT: [false],
        BILID: [false],
        BILIT: [false],
        BLOOD: [false],
        CA125: [false],
        CA: [false],
        CEA: [false],
        CHOL: [false],
        CORTIAM: [false],
        CORTIPM: [false],
        CREA: [false],
        CREACL: [false],
        CK: [false],
        CRP: [false],
        CRPHS: [false],
        CSC: [false],
        CST: [false],
        CSV: [false],
        CSU: [false],
        CVA: [false],
        CUL: [false],
        CUL_source: [''],
        DIG: [false],
        ECG: [false],
        LYTES: [false],
        ESTRA: [false],
        FERI: [false],
        FIT: [false],
        FOL: [false],
        FRU: [false],
        FSH: [false],
        GGT: [false],
        GLURAN: [false],
        AC: [false],
        PC50g: [false],
        GLU75: [false],
        PREG75: [false],
        HPYL: [false],
        DIA13HELI: [false],
        HBEL: [false],
        CBC: [false],
        HBA1CP: [false],
        HEPAG: [false],
        HEPAM: [false],
        HBS: [false],
        ANHBS: [false],
        HEPBC: [false],
        HEPC: [false],
        HIV: [false],
        HOLTER24: [false],
        HOLTER48: [false],
        HOLTER72: [false],
        LHOMO: [false],
        ELEPRO: [false],
        IMQUANT: [false],
        LD: [false],
        LH: [false],
        LIP: [false],
        LI: [false],
        MG: [false],
        MIALBP: [false],
        MONO: [false],
        UM: [false],
        PARVOG: [false],
        PARVOM: [false],
        PCA3: [false],
        PHOS: [false],
        Serum_BSQUAL: [false],
        PREG: [false],
        B_hCG_BSQUANT: [false],
        PROG: [false],
        PROL: [false],
        PROT: [false],
        PSA: [false],
        PT: [false],
        PTH: [false],
        PTT: [false],
        RA: [false],
        RETICP: [false],
        RUB: [false],
        RUBIGM: [false],
        SED: [false],
        SEPTIN9: [false],
        SPER: [false],
        SPECO: [false],
        CLOS: [false],
        OP1P_2P_3p: [false],
        OP1P_2P_3p_value: [''],
        STREP: [false],
        SYPH: [false],
        T3F: [false],
        T3: [false],
        T4F: [false],
        CTX: [false],
        TESBIO: [false],
        TESLI: [false],
        TEST: [false],
        TOXO: [false],
        TOXOM: [false],
        TRIG: [false],
        TSH: [false],
        TSHR4: [false],
        UREA: [false],
        URIC: [false],
        URI: [false],
        URINE_24HR_COLLECTION: [false],
        URINE_24HR_COLLECTION_VALUE: [''],
        B12: [false],
        VITD: [false]
      }),
      testSpecification: this.fb.group({
        PCRCHSD: [false],
        NGONOTAA: [false],
        TRICHTAA: [false],
        NGPCRD: [false],
        TGCD: [false],
        source_cervical: [false],
        source_vaginal: [false],
        source_urethral_aptima_swab: [false],
        source_urine_sterile_container: [false],
        other_analyses_instructions: [QC_OTHER_ANALYSES_FAX_BOILERPLATE]
      })
    });
  }
}
